export function slugify(value: string): string {
   return value.replaceAll(' ', '-');
}
